const usedIds = []

function makeUniqueId(possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', length = 6) {

	let used = true
	let newId = ''

	const generateId = () => {
		let id = ''
		for (let i = 0; i < length; i++) {
			id += possible.charAt(Math.floor(Math.random() * possible.length))
		}
		return id
	}

	while (used === true) {
		newId = generateId()
		if (!usedIds.includes(newId)) {
			used = false
			usedIds.push(newId)
		}
	}

	return newId
}

export default makeUniqueId
